// extracted by mini-css-extract-plugin
export default {"hotelHeadline":"BookHotel_hotelHeadline__xYVUU","luggageCaption":"BookHotel_luggageCaption__RIgFD","hotelParagraph":"BookHotel_hotelParagraph__B3bAI"};